import React from 'react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { MDXProvider } from '@mdx-js/react';
import MailTo from '@mdx/MailTo';
import Anchor from '@mdx/Anchor';
import Img from '@mdx/Img';
import { Box, Divider, Para, Display, Label } from 'workspace-core-ui';
import Score from '@mdx/Score';
import Confetti from '@components/Confetti';
import Level from '@mdx/Level';

const shortcodes = {
  MailTo,
  mailto: MailTo,
  a: Anchor,
  img: Img,
  undefined: 'div',
  Divider,
  para: Para,
  Para,
  Box,
  Score,
  Level,
  confetti: Confetti,
  Confetti,
  Display,
  Label,
};

export default ({ children }) => {
  // loosely check if what was passed in is an mdx compliant string
  if (children?.includes('isMDXComponent = true')) {
    return (
      <MDXProvider components={shortcodes}>
        <MDXRenderer>{children}</MDXRenderer>
      </MDXProvider>
    );
  }
  return children;
};
